import React, { useState } from "react";
import { PlusCircle, Edit, Trash2 } from "react-feather";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import DataTable from "../../../components/common/DataTable";
import { confirmDelete } from "../../../components/common/ConfirmDialog";
import { useGetRolesQuery, useDeleteRoleMutation } from "../rolesApi";
import RoleCreateModal from "../components/RoleCreateModal";
import RoleEditModal from "../components/RoleEditModal";

const RolesList = () => {
  const { data: roles = [], isLoading } = useGetRolesQuery();
  const [deleteRole] = useDeleteRoleMutation();
  const [showCreate, setShowCreate] = useState(false);
  const [editingRoleId, setEditingRoleId] = useState(null);

  const handleDelete = async (role) => {
    const confirmed = await confirmDelete({
      title: `Delete ${role.roleName}?`,
    });
    if (!confirmed) return;
    try {
      await deleteRole(role.roleId).unwrap();
      toast.success("Role deleted");
    } catch (error) {
      toast.error(error?.message || "Could not delete role");
    }
  };

  const columns = [
    { title: "Role Code", dataIndex: "roleCode" },
    { title: "Role Name", dataIndex: "roleName" },
    {
      title: "All Branches",
      dataIndex: "grantsAllBranchAccess",
      render: (value) => (
        <span className={`badge ${value ? "badge-linesuccess" : "badge-linedanger"}`}>
          {value ? "Yes" : "No"}
        </span>
      ),
    },
    {
      title: "Created",
      dataIndex: "createdDate",
      render: (value) => (value ? dayjs(value).format("DD MMM YYYY") : "-"),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, role) => (
        <div className="edit-delete-action">
          <button
            type="button"
            className="btn btn-link me-2 p-2"
            onClick={() => setEditingRoleId(role.roleId)}
          >
            <Edit size={16} />
          </button>
          <button
            type="button"
            className="btn btn-link p-2 text-danger"
            onClick={() => handleDelete(role)}
          >
            <Trash2 size={16} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Roles</h4>
              <h6>Business-function permission bundles</h6>
            </div>
          </div>
          <div className="page-btn">
            <button
              type="button"
              className="btn btn-added"
              onClick={() => setShowCreate(true)}
            >
              <PlusCircle className="me-2" size={16} />
              Add New Role
            </button>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <DataTable
                columns={columns}
                dataSource={roles}
                rowKey="roleId"
                loading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>

      <RoleCreateModal show={showCreate} onClose={() => setShowCreate(false)} />
      <RoleEditModal roleId={editingRoleId} onClose={() => setEditingRoleId(null)} />
    </div>
  );
};

export default RolesList;
